import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { EmployeePtoService } from '../employee-pto.service';
import { EmployeePto } from '../employee-pto';
import { EmployeePtoComponent } from '../employee-pto/employee-pto.component';
import { EmployeePtoRequestComponent } from '../employee-pto-request/employee-pto-request.component';

@Component({
    selector: 'app-employee-pto-list',
    templateUrl: './employee-pto-list.component.html',
    styleUrls: ['./employee-pto-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class EmployeePtoListComponent implements OnInit {
	constructor(
		private employeePtoService: EmployeePtoService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = employeePtoService.statuses;
		this.ptoReasons = employeePtoService.ptoReasons;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	employeePtos: any;
	employeePto: EmployeePto;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	ptoReasons: any;

	columns: any[] = [
		{ field: 'employeeName', header: 'Employee Name', width: 'auto' },
		{ field: 'status', header: 'status', width: 'auto' },
		{ field: 'startDate', header: 'Start Date', width: 'auto' },
		{ field: 'endDate', header: 'End Date', width: 'auto' },
		{ field: 'ptoHours', header: 'Hours', width: 'auto' },
		{ field: 'ptoReason', header: 'Reason', width: 'auto' },
		{ field: 'approvedBy', header: 'Approved by name', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.employeePtoId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-employeePto-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.employeePtoService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.employeePtos = res.data.employeePtos;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.employeePtos = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(employeePto: EmployeePto) {
		try {
			this.formLoading = true;
			this.employeePtoService.update(employeePto)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.employeePtos.map((employeePto, i) => {
							if (employeePto.employeePtoId === res.data.employeePto.employeePtoId) {
								this.employeePtos[i] = res.data.employeePto;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(employeePto: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(employeePto));

			this.formLoading = true;
			this.employeePtoService.delete(employeePto.employeePtoId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.employeePtos.splice(this.employeePtos.indexOf(employeePto), 1);
						this.recordTotal = this.employeePtos.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'EmployeePto ' + employeePto.employeePtoId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'EmployeePto ' + employeePto.employeePtoId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add EmployeePto'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(EmployeePtoComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}
	/**
	 * reqest for new PTO by employee
	 */

	onOpenFormAddReqest() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add EmployeePto Reqest'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(EmployeePtoRequestComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}

	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(employeePto: EmployeePto) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			employeePto: employeePto,
			title: 'Edit EmployeePto'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(EmployeePtoComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addEmployeePtoCB(employeePto: EmployeePto) {
		console.log('Adding EmployeePto: ' + JSON.stringify(employeePto));
		// if we don't have a employeePtos array yet...
		if (!this.employeePtos) {
			this.employeePtos = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.employeePtos.unshift(employeePto);

		// no idea what this is but it is required to update the array
		this.employeePtos = [...this.employeePtos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'EmployeePto ' + employeePto.employeePtoId + ' Added', life: 3000 });
	}

	updateEmployeePtoCB(employeePto: EmployeePto) {
		console.log('Updating EmployeePto: ' + JSON.stringify(employeePto));
		let itemIndex = this.employeePtos.findIndex((item: any) => item.employeePtoId === employeePto.employeePtoId);
		this.employeePtos[itemIndex] = employeePto;

		// no idea what this is but it is required to update the array
		this.employeePtos = [...this.employeePtos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'EmployeePto ' + employeePto.employeePtoId + ' Updated', life: 3000 });
	}

	deleteEmployeePtoCB(employeePto: EmployeePto) {
		console.log('Removing EmployeePto: ' + employeePto);
		this.employeePtos.splice(this.employeePtos.indexOf(employeePto), 1);
		this.recordTotal = this.employeePtos.length;

		// no idea what this is but it is required to update the array
		this.employeePtos = [...this.employeePtos];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'EmployeePto ' + employeePto.employeePtoId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.employeePtos ? this.first === (this.employeePtos.length - this.rows) : true; }
	isFirstPage(): boolean { return this.employeePtos ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(employeePto: any) {
		if (employeePto?.status) {
			const status = this.statuses.find((e: any) => e.value == employeePto.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getReasonName(employeePto: any) {
		if (employeePto?.ptoReason) {
			const reason = this.ptoReasons.find((e: any) => e.value == employeePto.ptoReason);
			return reason.name;
		}
		else {
			return '';
		}
	}
	getEmpFullName(employeePto: any) {
		let name = '';
		if (employeePto?.employeeProfileFirstName) {
			name += employeePto.employeeProfileFirstName ;
		}
		if (employeePto?.employeeProfileLastName) {
			name += ' '+employeePto.employeeProfileLastName ;
		}
		return name;
	}

	getApvrFullName(employeePto: any) {
		let name = '';
		if (employeePto?.approvedByFirstName) {
			name += employeePto.approvedByFirstName ;
		}
		if (employeePto?.approvedByLastName) {
			name += ' '+employeePto.approvedByLastName ;
		}
		return name;
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
